import HomePage from '../components/HomePage';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Cartwheel',
  'Cartwheel is an AI research lab and product company building foundation models for human and object motion and tools for media and physical AI.',
);

export default function HomeRoute() {
  return <HomePage />;
}
